import React, { Component } from 'react';
import { Button, ButtonToolbar, Table, Col, Grid } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import { ZoneTypeForm } from './ZoneTypeForm';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { ZoneTypeAPI } from '../../../api/datamanager/ZoneTypeAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';

export class ZoneTypes extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);
        this.state = {
            zoneTypes: [],
            zoneTypeSelected: undefined,
            showZoneTypeForm: false,
            showDeleteModal: false,
            showExecutingModal: false,
            filter: "",
            nameInputError: null,
            currentPage: 1,
            elementsPerPage: 10,
            title: '',
            alertTitle: undefined,
            icon: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            errorLoading: false,
            loading: true
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        this.getZoneTypes();
    }

    getZoneTypes() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        let zoneTypeSelectedId = typeof this.state.zoneTypeSelected !== 'undefined' ? this.state.zoneTypeSelected.id : undefined;

        ZoneTypeAPI.list(selectedProviderId)
            .then(response => JSON.parse(response))
            .then(data => {
                const totalPages = PaginationHelper.getTotalPages(data.length, this.state.elementsPerPage);
                this.setState({
                    zoneTypes: data,
                    currentPage: this.state.currentPage > totalPages ? totalPages : this.state.currentPage,
                    zoneTypeSelected: typeof zoneTypeSelectedId !== 'undefined' ? data.filter(zoneType => zoneType.id === zoneTypeSelectedId)[0] : undefined,
                    nameInputError: null,
                    showZoneTypeForm: false,
                    showDeleteModal: false,
                    showExecutingModal: false,
                    loading: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true,
                    showExecutingModal: false,
                    errorLoading: true
                })
            });
    }

    updateZoneTypeValue = (e, value) => {
        let { zoneTypeSelected } = this.state;
        zoneTypeSelected[value] = e.target.value;

        this.setState({
            zoneTypeSelected
        })
    }

    saveZoneType = () => {
        if (this.state.zoneTypeSelected.id !== undefined) {
            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    ZoneTypeAPI.update(this.state.zoneTypeSelected.id, this.state.zoneTypeSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Tipo de zona alterado com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            })
                            this.getZoneTypes()
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.getZoneTypes()
                        })
                })
            }
        } else {
            if (this.validInput()) {
                this.setState({
                    showExecutingModal: true
                }, () => {
                    ZoneTypeAPI.create(this.state.zoneTypeSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Tipo de zona criado com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            })
                            this.getZoneTypes()
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            })
                            this.getZoneTypes()
                        })
                })
            }
        }
    }

    deleteZoneType = (isToExecute) => {
        if (isToExecute) {
            this.setState({
                showDeleteModal: false,
                showExecutingModal: true
            }, () => {
                ZoneTypeAPI.delete(this.state.zoneTypeSelected.id)
                    .then(() => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Sucesso",
                            alertMessage: 'Tipo de zona removido com sucesso.',
                            alertStyle: 'success',
                            icon: 'ok',
                            showErrorModal: true
                        })
                        this.getZoneTypes()
                    }).catch((err) => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Erro",
                            alertMessage: err.message,
                            alertStyle: 'danger',
                            icon: 'remove',
                            showErrorModal: true
                        })
                        this.getZoneTypes()
                    })
            })
        }

        this.setState({
            showDeleteModal: false
        })
    }

    validInput() {
        let { nameInputError } = this.state;
        let errors = 0;

        nameInputError = null;

        if (this.state.zoneTypeSelected.name === "") {
            nameInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError
        })

        return errors > 0 ? false : true;
    }

    handleCreateClick = () => {
        this.setState({
            zoneTypeSelected: {
                name: "", aux: ""
            },
            showZoneTypeForm: true,
            title: 'Criar'
        })
    }

    handleEditClick = (zoneType) => {
        this.setState({
            zoneTypeSelected: zoneType,
            showZoneTypeForm: true,
            title: 'Editar'
        })
    }

    handleDeleteClick = (zoneType) => {
        this.setState({
            zoneTypeSelected: zoneType,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende eliminar o tipo de zona ${zoneType.name}?`,
            alertStyle: "warning",
            icon: 'alert'
        })
    }

    clearError = () => {
        this.setState({
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            showErrorModal: false
        })
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    renderZoneTypesTable(zoneTypes) {
        const { currentPage, elementsPerPage, filter } = this.state;

        const zoneTypesFiltered = SearchHelper.search({
            filter: filter, 
            data: zoneTypes, 
            fields: ["name", "aux"]
        });
        const totalPages = PaginationHelper.getTotalPages(zoneTypesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const zoneTypesToRender = zoneTypesFiltered.sort((a, b) => a.name.toUpperCase() !== b.name.toUpperCase() ? a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1 : 0)
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <Table responsive striped hover >
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Descrição</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            zoneTypesToRender.map((zoneType, idx) =>
                                <tr key={`zonetype-${idx}`}>
                                    <td>{zoneType.name}</td>
                                    <td>{zoneType.aux}</td>
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(zoneType)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(zoneType)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                <PaginationBuilder currentPage={this.state.currentPage} 
                    elementsPerPage={this.state.elementsPerPage} 
                    dataLength={zoneTypesFiltered.length} 
                    onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        );
    }

    render() {
        if (!this.state.errorLoading) {
            let contents = this.state.loading
                ? <LoadingSpinner />
                : this.renderZoneTypesTable(this.state.zoneTypes);

            return (
                <div>
                    {this.state.loading
                        ?
                        null
                        :
                        <TitleRow title="Tipos de zona" showSeparator={true}>
                            <Col className="padding-0" xs={2} sm={1} md={4}>
                                <ButtonToolbar className="pull-right title-row-col-btns">
                                    <Button onClick={this.handleCreateClick}>CRIAR</Button>
                                </ButtonToolbar>
                            </Col>
                            <Col className="padding-0" xs={10} sm={11} md={8}>
                                <div className="search-bar">
                                    <SearchBar onSearch={(a) => this.onSearch(a)} />
                                </div>
                            </Col>
                        </TitleRow>
                    }

                    <div className="margin-top-15">
                        {contents}
                    </div>

                    <ZoneTypeForm show={this.state.showZoneTypeForm} zoneType={this.state.zoneTypeSelected} nameInputError={this.state.nameInputError} onHide={() => this.getZoneTypes()} onChangeValue={this.updateZoneTypeValue} onSave={this.saveZoneType} title={this.state.title} />
                    <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteZoneType} />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                    <HandleMessage show={this.state.showExecutingModal} title={this.state.executingTitle} message={this.state.executingMessage} icon={this.state.exectuingIcon} style={this.state.executingStyle}
                        onHide={this.clearError} small noButtons />
                </div>
            );
        } else {
            return (
                <div>
                    <LoadingSpinner />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/zoneTypes/ZoneTypes.js